/* theme.js — Core interactions: sticky header, mobile nav, cart drawer, cart AJAX */

(function () {
  'use strict';

  /* ================================
     Sticky Header Shadow
     ================================ */
  var header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* ================================
     Mobile Navigation
     ================================ */
  var menuToggle = document.getElementById('menu-toggle');
  var menuClose = document.getElementById('menu-close');
  var mobileNav = document.getElementById('mobile-nav');

  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      mobileNav.classList.add('is-open');
      mobileNav.setAttribute('aria-hidden', 'false');
      menuToggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    });
  }
  if (menuClose && mobileNav) {
    menuClose.addEventListener('click', function () {
      mobileNav.classList.remove('is-open');
      mobileNav.setAttribute('aria-hidden', 'true');
      if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    });
  }

  /* ================================
     Cart Drawer
     ================================ */
  var cartDrawer = document.getElementById('cart-drawer');
  var cartToggle = document.getElementById('cart-toggle');
  var cartClose = document.getElementById('cart-close');
  var cartOverlay = document.getElementById('cart-overlay');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCart();
      if (mobileNav && mobileNav.classList.contains('is-open')) {
        mobileNav.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    }
  });

  /* ================================
     Cart AJAX Operations
     ================================ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action]');
    if (!btn) return;

    var action = btn.dataset.action;
    var key = btn.dataset.key;
    if (!key) return;

    e.preventDefault();

    var qtyEl = btn.closest('.cart-item')
      ? btn.closest('.cart-item').querySelector('.cart-item__qty-val')
      : null;
    var currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;

    var newQty;
    if (action === 'increase') newQty = currentQty + 1;
    else if (action === 'decrease') newQty = Math.max(0, currentQty - 1);
    else if (action === 'remove') newQty = 0;
    else return;

    updateCartItem(key, newQty);
  });

  /* Cause selector */
  document.addEventListener('change', function (e) {
    if (e.target.name !== 'cause') return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { 'Cause Selection': e.target.value }
      })
    });
  });

  /* Product form intercept — add to cart via AJAX */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;

    e.preventDefault();
    var formData = new FormData(form);
    var data = {
      items: [{
        id: parseInt(formData.get('id'), 10),
        quantity: 1
      }]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      refreshCartDrawer();
      openCart();
    });
  });

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function (r) { return r.json(); })
    .then(function () { refreshCartDrawer(); });
  }

  function refreshCartDrawer() {
    fetch('/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newDrawer = doc.getElementById('cart-drawer');
        if (newDrawer && cartDrawer) {
          cartDrawer.innerHTML = newDrawer.innerHTML;
          cartDrawer.classList.add('is-open');
          cartDrawer.setAttribute('aria-hidden', 'false');
          // Re-bind close button
          var newClose = cartDrawer.querySelector('#cart-close');
          if (newClose) newClose.addEventListener('click', closeCart);
          var newOverlay = cartDrawer.querySelector('#cart-overlay');
          if (newOverlay) newOverlay.addEventListener('click', closeCart);
        }
        // Update header cart count
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var badge = document.getElementById('cart-count');
            if (badge) {
              badge.textContent = cart.item_count;
              badge.style.display = cart.item_count > 0 ? '' : 'none';
            }
          });
      });
  }

  /* ================================
     Mobile Filter Toggle
     ================================ */
  var filterToggle = document.getElementById('filter-toggle');
  var filterSidebar = document.getElementById('collection-filters');
  if (filterToggle && filterSidebar) {
    filterToggle.addEventListener('click', function () {
      filterSidebar.classList.toggle('is-open');
    });
  }
})();
